export default "__VITE_ASSET__DvEyDUY___"